import { Box, Button, Chip, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import { Person as PersonIcon } from "@mui/icons-material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { fDate } from "../../utils/formatTime";
import CustomNoRowsOverlay from "../../newTestPrep/newComponent/TableCustomeComp/CustomNoRowsOverlay";

function SpecificTaskPage({ tasks, onClose }) {
  const navigate = useNavigate();
  const user_role = localStorage.getItem("userRole");

  const [tasksData, setTasksData] = useState(tasks);

  /*const handleViewMore = (row) => {
 
    
        if (user_role === 'admin' || user_role === 'trainer') {
          
            if (row.type_of_task.name_of_task_type === 'Demo request' || 
                row.type_of_task.name_of_task_type === 'Test prep demo' || 
                row.type_of_task.name_of_task_type === 'Evaluation demo') {
                console.log('Navigating to Demo Details');
                if(row.demo_id) {
                   // navigate(`/demodetails/${row.demo_id}`);
                   window.open(`/demodetails/${row.demo_id}`, '_blank');
                    onClose();
                } else {
                    //navigate('/page404')
                    window.open('/page404', '_blank');
                    onClose();
                }
               
            } else {
               // navigate(`/enquirydetails/${row.enquiry_id?.id}`);
                window.open(`/enquirydetails/${row.enquiry_id?.id}`, '_blank');
                onClose()
            }
        } else {
            console.log('Navigating to Enquiry Details');
            //navigate(`/enquirydetails/${row.enquiry_id?.id}`);
            window.open(`/enquirydetails/${row.enquiry_id?.id}`, '_blank');
            onClose()
        }
       
    };*/

  const handleViewMore = (row) => {
    if (user_role === "admin" || user_role === "trainer") {
      if (
        [/*'Demo request',*/ "Test prep demo", "Evaluation demo"].includes(
          row.type_of_task.name_of_task_type
        )
      ) {
        console.log("Navigating to Demo Details");
        if (row.demo_id) {
          window.open(`/demodetails/${row.demo_id}`, "_blank");
        } else {
          window.open("/page404", "_blank");
        }
      } else {
        window.open(`/enquirydetails/${row.enquiry_id?.id}`, "_blank");
      }
    } else {
      window.open(`/enquirydetails/${row.enquiry_id?.id}`, "_blank");
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Enquiry Name",
      flex: 2,
      minWidth : 150,
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.first_name || ""} ${params.row?.enquiry_id?.last_name || ""}`, // Use direct API fields
      renderCell: (params) => {
    
        return (
          <div>
            <Button size="small" onClick={() => handleViewMore(params.row)}>
            {params.row.enquiry_id?.first_name}
              {params.row.enquiry_id?.last_name}
            </Button>
          </div>
        );
      },
      /*renderCell: (params) => (
              <div>
                <Button size='small' onClick={() => handleViewMore(params.row)}>
                <PersonIcon /> {params.row.first_name} {params.row.last_name}
                </Button>
              </div>
            ),*/
    },

    {
      field: "taskType",
      headerName: "Type of Task",
      flex: 1,
      minWidth : 150,
      filterable: true,
      valueGetter: (params) =>
        `${params.row?.type_of_task?.name_of_task_type || ""}`,
      renderCell: (params) => (
        <div>{params.row.type_of_task?.name_of_task_type}</div>
      ),
    },
    {
      field: "due_date",
      headerName: "Due Date",
      flex: 1,
      minWidth : 150,
        renderCell: (params) => {
      const { due_date, createdAt } = params?.row || {};

      const dueDate = due_date ? new Date(due_date) : null;
      const createdDate = createdAt ? new Date(createdAt) : null;

      const displayDate =
        !dueDate || dueDate < createdDate ? createdDate : dueDate;

      return <div>{displayDate ? fDate(displayDate) : "-"}</div>;
    },
    },
    {
      field: "stage",
      headerName: "Stage",
      flex: 1,
      minWidth : 150,
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.stage_id?.name || ""}`,
  
      renderCell: (params) => (
        <div>{params.row.enquiry_id?.stage_id?.name}</div>
      ),
    },
    {
      field: "sub_service_id",
      headerName: "Sub Service",
      flex: 1,
      minWidth : 150,
      filterable: true,
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.sub_service_id?.name || ""}`,
      renderCell: (params) => (
        <div>{params.row.enquiry_id?.sub_service_id?.name}</div>
      ),
    },
    {
      field: "taskOwner",
      headerName: "Task Owner",
      flex: 1,
      minWidth : 150,
      valueGetter: (params) =>
        `${params.row?.task_owner.first_name || ""}`,
      renderCell: (params) => <div>{params.row.task_owner?.first_name}</div>,
    },
    {
      field: "createdBy",
      headerName: "Created By",
      flex: 1,
      minWidth : 150,
      valueGetter: (params) =>
        `${params.row?.created_by?.first_name || ""}`,
      renderCell: (params) => <div>{params.row.created_by?.first_name}</div>,
    },
    {
      field: "createdAt",
      headerName: "Created Date",
      flex: 1,
      minWidth : 150,
      renderCell: (params) => <div>{fDate(params.value)}</div>,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth : 150,
      renderCell: (params) => {
        let chipColor = "";
        let chipLabel = "";

        switch (params.value) {
          case 0:
            chipColor = "secondary";
            chipLabel = "Closed";
            break;
          case 1:
            chipColor = "error";
            chipLabel = "Open";
            break;
          default:
            chipColor = "orange";
            chipLabel = "Unknown";
        }

        return (
          <Chip
          size="normal"
          variant="contained"
            label={chipLabel}
            color={chipColor === "default-color" ? "default" : chipColor}
          />
        );
      },
    },
    {
      field: "closedBy",
      headerName: "Closed By",
      flex: 1,
      minWidth : 150,
      valueGetter: (params) =>
        `${params.row?.closed_by?.first_name || ""}`,
      renderCell: (params) => <div>{params.row.closed_by?.first_name}</div>,
    },
    {
      field: "closed_date",
      headerName: "Closed Date",
      flex: 1,
      minWidth : 150,
      renderCell: (params) => <div>{fDate(params.value)}</div>,
    },
  ];

  return (
    <>
      <div style={{ height: "400", width: "100%" }}>
        <DataGrid
          columns={columns}
          rows={tasksData}
          autoHeight
          pagination
          slots={{
            noRowsOverlay: CustomNoRowsOverlay,
          }}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          pageSizeOptions={[25, 50, 100]}
          // pageSize={tasksPerPage}
          // rowCount={tasksPerPage * totalPages}
          //paginationMode="server"
          //onPageChange={handlePageChange}
          s
        />
      </div>
    </>
  );
}

export default SpecificTaskPage;
